import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { DepositHistoryDetailTemplate } from 'components/Templates'

const DepositHistoryDetail: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const paths = pathname.split('/')
  const payoutId = paths[paths.length - 1]
  const title = '入金履歴'
  return (
    <Layout headline={'入金履歴明細'} iconPath={'/icon/white/revenue.svg'} title={title}>
      <DepositHistoryDetailTemplate payoutId={payoutId} title={title} />
    </Layout>
  )
}

export default DepositHistoryDetail
